import { formatNaira, formatDate } from '../lib/format'
import { ArrowRight } from 'lucide-react'

export default function TransactionsTable({ rows, onViewAll, caption = 'Recent Transactions' }) {
  return (
    <div className="surface">
      <div className="flex items-center justify-between px-5 py-3.5 border-b border-edge">
        <h3 className="text-sm font-semibold text-ink">{caption}</h3>
        {onViewAll && (
          <button onClick={onViewAll} className="link-secondary flex items-center gap-1 min-h-[44px]">
            View All <ArrowRight size={12} />
          </button>
        )}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead>
            <tr className="bg-slate-50 text-left text-xs uppercase tracking-wide text-muted">
              <th className="px-5 py-2.5 font-semibold">Date</th>
              <th className="px-5 py-2.5 font-semibold">Description</th>
              <th className="px-5 py-2.5 font-semibold text-right">Amount</th>
              <th className="px-5 py-2.5 font-semibold">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-edge">
            {rows.map((r) => (
              <tr key={r.id} className="hover:bg-slate-50 transition-colors">
                <td className="px-5 py-3 font-mono text-xs text-slate-600">{formatDate(r.date)}</td>
                <td className="px-5 py-3 text-ink">{r.description}</td>
                <td className={`px-5 py-3 text-right font-mono ${r.amount < 0 ? 'text-rose-600' : 'text-ink'}`}>
                  {r.amount < 0 ? '-' : ''}{formatNaira(Math.abs(r.amount))}
                </td>
                <td className="px-5 py-3">
                  {r.status ? (
                    <span
                      className={`inline-flex items-center px-2 py-0.5 text-xs font-medium border ${
                        r.status === 'Completed'
                          ? 'border-emerald-300 text-emerald-700 bg-emerald-50'
                          : 'border-amber-300 text-amber-700 bg-amber-50'
                      }`}
                    >
                      {r.status}
                    </span>
                  ) : (
                    <span className="text-xs text-muted">{r.type}</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
